rdefine('app/products/components/TabChoiceLanguage',['backbone'],function(Backbone) {
    return Backbone.Ribs.View.extend({
        tagName:'li',
        className:'',
        bindings:{
            el:{
                classes:{
                    active:'model.active'
                }
            },
            a:{
                text: {
                    data: 'model.lang',
                    processor: function(lang) {
                        return (lang && lang.name)?lang.name:'-';
                    }
                }
            }
        },
        events:{
            "click a":"setActive",
            "click a button":"removeMe"
        },
        initialize:function() {
            this.$el.html('<a href="#"></a>');
        },
        setActive:function() {
            this.collection.setActive(this.model);
            return false;
        },
        removeMe:function() {
            //add ask
            this.collection.remove(this.model);
            return false;
        }
    });
});